/* eslint-disable jsx-a11y/alt-text */
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { ConsultFormModal } from "../../components/CommonFormModal";
import { Link } from "../../components/Link";
import { VerifyScan } from "../../components/VerifyScan";
import "./styles.less";
export const VerifyPageContentBlock = ({
  imgUrl,
  content,
  position = "back",
  aside = null,
  layout,
}) => {
  return (
    <div className={`verifyPage-content ${position} ${layout}`}>
      <div className="text-box">{content}</div>
      {aside || (
        <div className="img-box">
          <img src={imgUrl} />
        </div>
      )}
    </div>
  );
};

export const VerifyPageContent = () => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  const cardOneContent = {
    // imgUrl: "//files.authing.co/authing-website/verify-page-login.png",
    position: "back",
    content: (
      <div>
        <h3 className="headline">{t("learn.verifyPage.intro.title")}</h3>
        <div className="paragraph">{t("learn.verifyPage.intro.descript")}</div>
        <div className="paragraph">
          <span>{t("learn.verifyPage.intro.descript1")}</span>
          <Link href="/developer">
            {t("learn.verifyPage.intro.weixinLogin")}
          </Link>
        </div>
      </div>
    ),
    aside: (
      <div className="wecaht-mini-login">
        <div className="scan-img">
          <img src="//files.authing.co/authing-website/verify-page-login-new.png" />
        </div>
        <div className="verify-scan-login">
          <VerifyScan />
        </div>
      </div>
    ),
  };
  const cardTwoContent = {
    imgUrl: "//files.authing.co/authing-website/verify-page-miniprograme.png",
    position: "front",
    layout: "layout",
    content: (
      <div>
        <h3 className="headline">{t("learn.verifyPage.step-one.title")}</h3>
        <div className="paragraph">
          {t("learn.verifyPage.step-one.descript1")}
        </div>
        <div className="paragraph">
          {t("learn.verifyPage.step-one.descript2")}
          <Link
            href={`https://mp.weixin.qq.com/wxopen/waregister?action=step1&token=&lang=zh_CN`}
            target="_blank"
            rel="noopener noreferrer"
          >
            {t("learn.verifyPage.step-one.weixinPlatform")}
          </Link>
          {t("learn.verifyPage.step-one.descript3")}
        </div>
        <div className="paragraph consult">
          {t("learn.verifyPage.step-one.descript4")}
          <Link
            onClick={() => {
              setVisible(true);
            }}
          >
            {t("learn.verifyPage.step-one.consult")}
          </Link>
        </div>
        <ConsultFormModal {...{ visible, setVisible }} />
      </div>
    ),
  };
  const cardThreeContent = {
    imgUrl: "//files.authing.co/authing-website/verify-page-console.png",
    position: "back",
    layout: "layout",
    content: (
      <div>
        <h3 className="headline">{t("learn.verifyPage.step-two.title")}</h3>
        <div className="paragraph">
          {t("learn.verifyPage.step-two.descript")}
        </div>
        <div className="paragraph">
          <div className="text">{t("learn.verifyPage.step-two.list1")}</div>
        </div>
        <div className="paragraph">
          <div className="text">{t("learn.verifyPage.step-two.list2")}</div>
        </div>
        <div className="paragraph">
          <div className="text">{t("learn.verifyPage.step-two.list3")}</div>
        </div>
        <div className="paragraph">
          <div className="text">{t("learn.verifyPage.step-two.list4")}</div>
        </div>
      </div>
    ),
  };
  return (
    <div className="verify-content-scan">
      <VerifyPageContentBlock {...cardOneContent} />
      <VerifyPageContentBlock {...cardTwoContent} />
      <VerifyPageContentBlock {...cardThreeContent} />
    </div>
  );
};
